import Separator from '@react/shared/components/Separator';
import { CARE_TYPES_OBJECT } from '@sly/core/constants/careTypes';
import { stateNames } from '@sly/core/constants/geo';
import clsxm from '@sly/frontend/common/lib/clsxm';
import { useState } from 'react';
import slugify from 'slugify';
import { Button } from 'sly/system';
import Heading from 'sly/system/Heading';
import Link from 'sly/system/Link';

export default function AgentCities({
  cities,
  firstName,
  separator = true,
}: {
  cities: string[];
  firstName: string;
  separator?: boolean;
}) {
  const [expanded, setExpanded] = useState(false);
  return (
    <div className='mb-12'>
      {separator && <Separator className='mt-2 mb-20' />}
      <Heading className='mb-4 w-[var(--col3)] flex-shrink-0 break-words md:w-[var(--col4)]'>
        {firstName}&apos;s cities
      </Heading>
      <div
        className={clsxm(
          'grid grid-cols-1 gap-y-2 overflow-hidden sm:grid-cols-2 lg:grid-cols-3',
          expanded ? 'max-h-full' : 'max-h-[18rem] lg:max-h-[12rem]'
        )}
      >
        {cities.map((city) => {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          const [cityName, stateAbbr]: [string, keyof typeof stateNames] =
            city.split(', ');
          return (
            <Link
              className='text-viridian-base'
              key={city}
              to={`/${CARE_TYPES_OBJECT.assistedLiving}/${slugify(
                stateNames[stateAbbr],
                {
                  lower: true,
                  strict: true,
                }
              )}/${slugify(cityName, {
                lower: true,
                strict: true,
              })}`}
            >
              {city}
            </Link>
          );
        })}
      </div>
      {cities?.length > 18 && (
        <Button
          className='mt-3'
          onClick={() => setExpanded(!expanded)}
          variant='outlined'
        >
          {expanded ? 'See less' : 'See more'}
        </Button>
      )}
    </div>
  );
}
